<template>
  <div>
    <div v-if="$userInfo.isSystemAccount">
      <app-detail-header :show-toggle="true"
        :show-new="false"
        :show-print="false"
        :show-delete="company && company.isActive && !isNew && $userInfo.isSystemAccount"
        :show-save="isNew"
        :show-lock="false"
        :show-cancel="true"
        @appDetailHeaderButtonClicked="onHeaderButtonClicked" />
      <div class="columns is-gapless">
        <div class="column is-narrow">
          <company-side-menu />
        </div>
        <div class="column">
          <router-view ref="currentChild" />
        </div>
      </div>
    </div>
    <div v-else
      class="is-flex is-justify-content-center pt-5">
      <div class="notification is-danger is-flex is-justify-content-center is-size-4"
        style="width: 50%">You do not have permissions on this page</div>
    </div>
    <confirm-modal v-if="company && company.name"
      :active.sync="isConfirmModalActive"
      @ok="deleteEntity(true)"
      @cancel="deleteEntity(false)"
      :ok-text="'Yes'"
      :cancel-text="'No'">
      <p slot="text-title">Delete Company</p>
      <p slot="text-content">
        Company
        <span class="has-text-primary has-text-weight-bold">{{ `${company.name}` }}</span> will be deleted. Continue?
      </p>
    </confirm-modal>
  </div>
</template>

<script>
import AppDetailHeader from '@/components/AppDetailHeader'
import { AppHeaderButtonTypes } from '@/enums'
import CompanySideMenu from './CompanySideMenu.vue'
import SuperadminCompanyRoutes from '../../views/superadmin/company/route-types'
import { CompanySettingService } from '../../services'
import HttpStatus from '../../components/http-status'
import { EventHubTypes } from '../../enums'
import { ConfirmModal } from '@/components/BulmaModal'

export default {
  name: 'CompanyView',
  components: {
    AppDetailHeader,
    CompanySideMenu,
    ConfirmModal
  },
  mixins: [],
  props: {},
  data: () => {
    return { isConfirmModalActive: false }
  },
  computed: {
    isNew() {
      const { companyId } = this.$route.params
      return companyId === 'new'
    },
    isHQ() {
      const { companyType } = this.$route.params
      return companyType === 'hq'
    },
    newCompany() {
      var data = {}
      if (this.$refs.currentChild.companyDetails) {
        data = {
          companyDetails: this.$refs.currentChild.companyDetails,
          user: this.$refs.currentChild.user
        }
        return data
      }
      return this.$store.getters['companysetting/newCompany']
    },
    company() {
      var company = this.$store.getters['companysetting/company']
      if (company) {
        return company
      }
      return {}
    }
  },
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  beforeDestroy() {},
  methods: {
    onHeaderButtonClicked(action) {
      switch (action) {
        case AppHeaderButtonTypes.AddNew:
          break
        case AppHeaderButtonTypes.Print:
          break
        case AppHeaderButtonTypes.Delete:
          this.isConfirmModalActive = true
          break
        case AppHeaderButtonTypes.Save:
          if (this.isNew) {
            this.save()
          }
          break
        case AppHeaderButtonTypes.Cancel:
          this.cancel()
          break
      }
    },
    cancel() {
      this.$router.push({ name: SuperadminCompanyRoutes.CompanyListView.name })
    },
    async save() {
      if (!this.newCompany || !this.newCompany.companyDetails) {
        this.$toast.open({
          message: 'No company data to save',
          type: 'is-danger',
          position: 'is-top',
          queue: false
        })
        return
      }
      var isError = true
      const detailSetting = this.$refs.currentChild
      if (detailSetting) {
        detailSetting.$v.$touch()
        isError = detailSetting.$v.$error
        if (
          detailSetting.$refs.assetPhones !== undefined &&
          detailSetting.$refs.assetEmails !== undefined &&
          detailSetting.$refs.assetAddresses !== undefined
        ) {
          isError =
            isError ||
            detailSetting.$refs.assetPhones.$v.phones.$error ||
            detailSetting.$refs.assetEmails.$v.emails.$error ||
            detailSetting.$refs.assetAddresses.$v.addresses.$error ||
            !detailSetting.$refs.assetAddresses.$v.uniqueAddressType
        }
        isError = isError || detailSetting.validateCountrySectionError()
        // isError = detailSetting.validateError || detailSetting.validateCountrySectionError()
      }
      if (isError) {
        this.$toast.open({
          message: 'Please fix validation errors before saving.',
          type: 'is-danger',
          position: 'is-top',
          queue: false
        })
        return
      }
      try {
        var response
        this.$showSpinner('Saving...')
        this.newCompany.isHQ = this.isHQ
        response = await CompanySettingService.postCompany(this.newCompany)
        if (response.status === HttpStatus.NO_CONTENT) {
          this.$notification.openNotificationWithType('success', 'Company', 'Save successful')
        } else if (response.status === HttpStatus.CREATED) {
          this.$notification.openNotificationWithType('success', 'Company', 'New company added')
        }
        this.$eventHub.$emit(EventHubTypes.EntitySaved)
        this.$router.push({ name: SuperadminCompanyRoutes.CompanyListView.name })
        // this.$router.push({ name: CompanyRoutes.CompanyDetail.name, params: { companyId: response.data.companyId } })
      } catch (e) {
        console.log(e)
        if (e.response.request.status === HttpStatus.CONFLICT) {
          this.isSaveConflictModalActive = true
        } else if (e.response.request.status === HttpStatus.BAD_REQUEST) {
          var errormessage = getErrorMessage(e.response.data.message).message
          this.$notification.openNotificationWithType('danger', title, errormessage || message)
        } else {
          this.$notification.openMessageXhrError('', e)
        }
      } finally {
        this.$hideSpinner()
      }
    },
    async delete() {
      this.$showSpinner('Saving...')
      await CompanySettingService.deleteCompany(this.$route.params.companyId)
      this.$notification.openNotificationWithType('success', 'Company', 'Company deleted')
      this.$hideSpinner()
      this.$router.push({ name: SuperadminCompanyRoutes.CompanyListView.name })
    },
    deleteEntity(confirmDelete) {
      this.isConfirmModalActive = false
      if (confirmDelete) {
        this.delete()
      }
    }
  },
  async beforeRouteLeave(to, from, next) {
    this.$store.dispatch('companysetting/clearSnapshots')
    this.$store.dispatch('companysetting/clearNewCompany')
    next()
  }
}
</script>
